import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service =  {
    name: 'PipelinePlus',
    label: 'Pipeline+',
    permissionId: 'pipelineplus',
    iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: true,
  data: [
  ],
  layers: [
    // {
    //   name: 'Sentinel1Arctic',
    //   label: 'Sentinel 1 (75 m)',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'Sentinel1Arctic',
    //   secondary: true
    // },
    // {
    //   name: 'Sentinel2Pipeline',
    //   label: 'Medium resolution',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'Sentinel2Pipeline',
    //   secondary: true
    // },
    {
      name: 'PlanetLabs',
      label: 'Planet Scope',
      opacity: 'raster-opacity',
      planetList: true,
      // datetimeId: 'Sentinel2Pipeline',
      secondary: false,
      open: true,
    },
    // {
    //   name: 'PlanetLabs',
    //   label: 'Planet Labs',
    //   opacity: 'raster-opacity',
    //   // datetimeId: 'Sentinel2Pipeline',
    //   secondary: true
    // },
    // {
    //   name: 'PipelineGreen',
    //   label: 'Analysis',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
    {
      name: 'EnbridgePipeline',
      label: 'Enbridge Pipeline',
      opacity: 'vector-opacity',
      hidden: true,
    },
    ],
  locations: [
    {
      name: 'MackinawCity',
      label: 'Mackinaw City',
      latitude: 45.783889,
      longitude: -84.7278,
      maxBounds: [[-150, -85], [80, 85]],
      zoom: [10]
    },
    {
      name: 'Guara',
      label: 'Guara',
      latitude: -20.428333,
      longitude: -47.824167,
      zoom: [10]
    },
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/PipelinePlus.js